// src/pages/customer/customerpanel/OverviewPanel.jsx
import React from 'react';
import StatCard  from '../customerwidgets/StatCard';
import OrderRow  from '../customerwidgets/OrderRow';

export default function OverviewPanel({ stats, myOrders, onNavigate }) {
  const recentOrders = myOrders?.slice(0, 3) || [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-black text-on-surface">Dashboard Overview</h2>
        <p className="text-sm text-secondary mt-1">Here's a summary of your activity.</p>
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard
          icon="receipt_long"
          label="My Orders"
          value={stats?.totalOrders ?? 0}
          sub={`${stats?.pendingOrders ?? 0} pending`}
          color="text-primary"
        />
        <StatCard
          icon="favorite"
          label="Wishlist"
          value={stats?.wishlistCount ?? 0}
          sub="Saved animals"
          color="text-tertiary"
        />
        <StatCard
          icon="payments"
          label="Total Spent"
          value={`₹${(stats?.totalSpent ?? 0).toLocaleString()}`}
          sub="Lifetime purchases"
          color="text-secondary"
        />
      </div>

      {/* Recent orders */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-outline-variant/10">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-black text-on-surface text-sm">Recent Orders</h3>
          <button
            onClick={() => onNavigate?.('orders')}
            className="text-xs font-bold text-primary hover:underline"
          >
            View all
          </button>
        </div>

        {recentOrders.length === 0 ? (
          <p className="text-sm text-secondary text-center py-6">No orders yet.</p>
        ) : (
          recentOrders.map(order => <OrderRow key={order.id} order={order} />)
        )}
      </div>
    </div>
  );
}
